export class InfraExceptionError extends Error {
  constructor(message = 'BusinessError') {
    super(message);
  }
}
